import { render, staticRenderFns } from "./UiReadMoreClamp.vue?vue&type=template&id=9a560bc6&scoped=true&"
import script from "./UiReadMoreClamp.vue?vue&type=script&lang=js&"
export * from "./UiReadMoreClamp.vue?vue&type=script&lang=js&"
import style0 from "./UiReadMoreClamp.vue?vue&type=style&index=0&id=9a560bc6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a560bc6",
  null
  
)

export default component.exports